<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>{{ $route.meta.name }}管理</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $route.meta.name }}列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="row">
      <div class="col-sm-12">
        <div class="panel">
          <btn-tag
            href="/factories/new"
            :text="'添加' + $route.meta.name"
            :auth-id="33101"
            btn-class="btn-purple"
            module-name="orders"
          >
          </btn-tag>
          <factory-table :items="factories.list"></factory-table>
          <pagination
            :records="factories.count"
            :page="page"
            :per-page="20"
            @paginate="loadData"
          ></pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { factoryList } from '@/service/getData'
import FactoryTable from './table'

export default {
  components: {
    FactoryTable,
  },
  data() {
    return {
      page: 1,
      factories: {
        list: [],
        count: 0,
      },
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      let res = await factoryList({
        page: this.page - 1,
      })

      if (res.status != 0) return false
      this.factories = res.data
    },
    async loadData(page) {
      this.page = page
      this.getData()
    },
  },
}
</script>